import React from "react"
import {ReactComponent as BackIcon} from "../../../assets/images/icons/back.svg"
import NotificationBellContainer from "./notification_bell_container"

class PageHeader extends React.Component {
  render() {
    const {title, subtitle, back, backLink} = this.props

    return <div className={`pageHeading${this.props.loggedOut ? '' : ' appPageHeader'}`}>
      <div>
        {back && backLink && <a className="pageHeadingBack" href={backLink}>
          <BackIcon className="me-3" />
          {back}
        </a>}
        {back && !backLink && this.props.onBack && <a className="pageHeadingBack" href="#" onClick={(e) => { e.preventDefault(); this.props.onBack(); }}>
          <BackIcon className="me-3" />
          {back}
        </a>}
        <div>
          <h3 className="dashboardSubHeading appPageTitle m-0" id={this.props.loggedOut ? "pageHeaderLoggedOut" : ""}>{title}</h3>
          {subtitle && !back && <div className="welcomeBackSubHeading">{subtitle}</div>}
        </div>
      </div>
      {!this.props.loggedOut && this.props.showNotifications !== false && <NotificationBellContainer />}
    </div>
  }
}

export default PageHeader